import angular from 'angular';

import PaymentStatusServ from '../../services/payment-status';

function CaseStatus(PaymentStatusServ) {
	return {
		restrict: 'A',
		template: require('./caseStatus.html'),
		link: function ($scope) {
			$scope.casePaymentExpired = PaymentStatusServ.isExpired('case');
		}
	};
}
CaseStatus.$inject = ['PaymentStatusServ'];

export default angular.module('directives.case-status', [PaymentStatusServ])
	.directive('caseStatus', CaseStatus)
	.name;



// WEBPACK FOOTER //
// ./project/directives/case-status/index.js